import React from "react";
import * as yup from "yup";
import { Form } from "react-final-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/material";
import { AuthWrapper } from "../../../_uiComponents/common/AuthWrapper";
import UiInput from "../../../_uiComponents/UiInput";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import { forgotPasswordEmailVeryficationRequest } from "../../../../_redux/_actions";
import Validator from "../../../../_helpers/validate.schema";

const validateSchema = () =>
     yup.object().shape({
          email: yup
               .string()
               .required("Email is required.")
               .email("Email must be a valid email."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function ForgetPassword(props) {
     const actionDispatch = useDispatch();

     const navigate = useNavigate();

     const submit = async (values, form) => {
          actionDispatch(
               forgotPasswordEmailVeryficationRequest({ ...values, form }),
          );
     };

     return (
          <>
               <AuthWrapper heading="Forget Password">
                    <Box component="div" sx={{ width: "100%" }}>
                         <div className="sba-auth-top-heading">
                              <h5>
                                   Please enter your registered email address
                              </h5>
                         </div>
                         <Form
                              onSubmit={submit}
                              validate={onValidate}
                              render={({
                                   handleSubmit,
                                   hasValidationErrors,
                              }) => (
                                   <form onSubmit={validateSchema}>
                                        <>
                                             <UiInput
                                                  type="text"
                                                  label="Enter Email"
                                                  name="email"
                                             />
                                             <Grid container sx={{ mb: 13 }}>
                                                  <Grid
                                                       item
                                                       xs
                                                       sx={{
                                                            textAlign: "right",
                                                       }}
                                                  >
                                                       <UiButton
                                                            name="Next"
                                                            variant="contained"
                                                            size="medium"
                                                            onClick={
                                                                 handleSubmit
                                                            }
                                                       />
                                                  </Grid>
                                             </Grid>
                                        </>
                                   </form>
                              )}
                         />
                         <p className="sba-login-bottom-support-mail">
                              Please reach{" "}
                              <span>support@sherbetrewards.com </span>
                              for further queries
                         </p>
                    </Box>
               </AuthWrapper>
          </>
     );
}
